module.exports = __webpack_public_path__ + "static/media/PDF_80.67ffab3d.pdf";